module.exports = __webpack_public_path__ + "static/Hexomatic_Translation-716947650433e776a31b06b3eb601a56.gif";